import Toggle from '@doordash/component-toggle'
import {
  InlineChildren,
  Inset,
  Stack,
  StackChildren,
  Text,
} from '@doordash/design-language'
import * as React from 'react'

type Variant = 'horizontal' | 'vertical'
type Value = string | number | boolean

type RadioLabelProps = {
  htmlFor: string
  label: string
}

type RadioGroupOption = {
  label: string
  value: Value
}

type RadioGroupComponentProps = {
  variant?: Variant
  value: Value
  options: RadioGroupOption[]
  onChange: (value: Value) => void
}

const RadioLabel: React.FC<RadioLabelProps> = ({ htmlFor, label }) => (
  <label htmlFor={htmlFor}>
    <Text styles={Text.Styles.Medium16}>{label}</Text>
  </label>
)

export const RadioGroupComponent: React.FC<RadioGroupComponentProps> = ({
  variant = 'horizontal',
  options,
  value: selectedValue,
  onChange,
  ...props
}) => {
  const Layout = variant === 'vertical' ? StackChildren : InlineChildren

  return (
    <Inset verticalSize={Inset.Sizes.Medium} horizontalSize={Inset.Sizes.None}>
      <Layout size={Layout.Sizes.Medium}>
        {options.map(({ label, value }) => (
          <Stack>
            <Toggle
              label={label}
              renderLabel={RadioLabel}
              isSelected={value === selectedValue}
              type={Toggle.Types.Radio}
              onChange={() => onChange(value)}
              {...props}
            />
          </Stack>
        ))}
      </Layout>
    </Inset>
  )
}
